import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a771aea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-smo-mode-badge success-badge" }
const _hoisted_2 = { class: "nge-smo-hint success-hint" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-mode-badge split-badge" }, " CUT MODE ", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-smo-groups" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-dot red-dot" }, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-label" }, "RED", -1 /* HOISTED */))
const _hoisted_8 = { class: "nge-smo-group-count" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-divider" }, "|", -1 /* HOISTED */))
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-dot blue-dot" }, null, -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-label" }, "BLUE", -1 /* HOISTED */))
const _hoisted_13 = { class: "nge-smo-group-count" }
const _hoisted_14 = {
  key: 0,
  class: "nge-smo-actions"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-key-hint" }, [
  /*#__PURE__*/_createElementVNode("kbd", null, "G"),
  /*#__PURE__*/_createTextVNode(" Swap")
], -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-key-hint" }, [
  /*#__PURE__*/_createElementVNode("kbd", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" Submit")
], -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Esc", -1 /* HOISTED */))
const _hoisted_18 = {
  key: 1,
  class: "nge-smo-loading-indicator"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-spinner" }, null, -1 /* HOISTED */))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-mode-badge merge-badge" }, " MERGE MODE ", -1 /* HOISTED */))
const _hoisted_22 = {
  key: 0,
  class: "nge-smo-actions"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-key-hint" }, [
  /*#__PURE__*/_createElementVNode("kbd", null, "Ctrl+Click"),
  /*#__PURE__*/_createTextVNode(" Set points")
], -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-key-hint" }, [
  /*#__PURE__*/_createElementVNode("kbd", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" Submit")
], -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Esc", -1 /* HOISTED */))
const _hoisted_27 = {
  key: 1,
  class: "nge-smo-loading-indicator"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-spinner" }, null, -1 /* HOISTED */))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 0,
  class: "nge-smo-merge-panel"
}
const _hoisted_31 = { class: "nge-smo-merge-panel-header" }
const _hoisted_32 = { class: "nge-smo-merge-panel-list" }
const _hoisted_33 = { class: "nge-smo-merge-num" }
const _hoisted_34 = { class: "nge-smo-seg-id" }
const _hoisted_35 = {
  key: 0,
  class: "nge-smo-merge-arrow"
}
const _hoisted_36 = {
  key: 1,
  class: "nge-smo-seg-id"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "nge-smo-result-icon" }
const _hoisted_39 = { class: "nge-smo-result-text" }
const _hoisted_40 = {
  key: 0,
  class: "nge-smo-result-retry"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "overlay-slide" }, {
      default: _withCtx(() => [
        ($setup.isVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["nge-split-merge-overlay", {
        multicut: $setup.isMulticut && !$setup.isPendingClose,
        merge: $setup.isMerge && !$setup.isPendingClose,
        submitting: $setup.isSubmitting,
        'bar-success': $setup.isPendingClose && $setup.resultIsSuccess,
        'bar-error': $setup.isPendingClose && $setup.resultIsError,
        'bar-inline-success': $setup.hasInlineResult && $setup.resultIsSuccess,
        'bar-inline-error': $setup.hasInlineResult && $setup.resultIsError,
      }])
            }, [
              _createCommentVNode(" SUCCESS / ERROR CLOSE STATE — replaces normal content "),
              ($setup.isPendingClose)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_1, _toDisplayString($setup.resultIsSuccess ? 'SUCCESS' : 'ERROR'), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.store.resultText), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : ($setup.isMulticut)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" MULTICUT / SPLIT MODE "),
                      _hoisted_3,
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-group red", { active: $setup.isRedActive }]),
                          onClick: _cache[0] || (_cache[0] = $event => (!$setup.isRedActive && $setup.swapGroup())),
                          title: $setup.isRedActive ? 'Red group (active)' : 'Click to switch to Red'
                        }, [
                          _hoisted_6,
                          _hoisted_7,
                          _createElementVNode("span", _hoisted_8, _toDisplayString($setup.store.redPointCount) + " pt" + _toDisplayString($setup.store.redPointCount !== 1 ? 's' : ''), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_5),
                        _hoisted_9,
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-group blue", { active: $setup.isBlueActive }]),
                          onClick: _cache[1] || (_cache[1] = $event => (!$setup.isBlueActive && $setup.swapGroup())),
                          title: $setup.isBlueActive ? 'Blue group (active)' : 'Click to switch to Blue'
                        }, [
                          _hoisted_11,
                          _hoisted_12,
                          _createElementVNode("span", _hoisted_13, _toDisplayString($setup.store.bluePointCount) + " pt" + _toDisplayString($setup.store.bluePointCount !== 1 ? 's' : ''), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_10)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["nge-smo-hint", { 'error-hint': $setup.hasInlineResult && $setup.resultIsError }])
                      }, _toDisplayString($setup.contextHint), 3 /* TEXT, CLASS */),
                      (!$setup.isSubmitting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("button", {
                              class: "nge-smo-action-btn clear-btn",
                              onClick: $setup.clearPoints,
                              title: "Clear all points"
                            }, "Clear"),
                            _hoisted_15,
                            _hoisted_16,
                            _createElementVNode("button", {
                              class: "nge-smo-action-btn cancel-btn",
                              onClick: $setup.cancelTool,
                              title: "Exit cut mode"
                            }, [
                              _hoisted_17,
                              _createTextVNode(" Cancel")
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($setup.isSubmitting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($setup.isMerge)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createCommentVNode(" MERGE MODE "),
                        _hoisted_21,
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-hint merge-hint", { 'error-hint': $setup.hasInlineResult && $setup.resultIsError }])
                        }, _toDisplayString($setup.contextHint), 3 /* TEXT, CLASS */),
                        (!$setup.isSubmitting)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("label", {
                                class: "nge-smo-auto-submit",
                                title: "Auto-submit merges when both points are placed",
                                onClick: _withModifiers($setup.toggleAutoSubmit, ["prevent"])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["nge-smo-checkbox", { checked: $setup.store.autoSubmit }])
                                }, _toDisplayString($setup.store.autoSubmit ? '☑' : '☐'), 3 /* TEXT, CLASS */),
                                _createTextVNode(" auto-submit ")
                              ], 8 /* PROPS */, _hoisted_23),
                              _hoisted_24,
                              _hoisted_25,
                              _createElementVNode("button", {
                                class: "nge-smo-action-btn cancel-btn",
                                onClick: $setup.cancelTool,
                                title: "Exit merge mode"
                              }, [
                                _hoisted_26,
                                _createTextVNode(" Cancel")
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.isSubmitting)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Merge segment queue (vertical list, left side) "),
    _createVNode(_Transition, { name: "merge-list-fade" }, {
      default: _withCtx(() => [
        ($setup.isMerge && $setup.hasMergeSegments && !$setup.isPendingClose)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, " Merge Queue (" + _toDisplayString($setup.store.mergeSegments.length) + ") ", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.mergeSegments, (pair, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "nge-smo-merge-row"
                  }, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(i + 1) + ".", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(pair[0]), 1 /* TEXT */),
                    (pair[1])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, "⇄"))
                      : _createCommentVNode("v-if", true),
                    (pair[1])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(pair[1]), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      class: "nge-smo-merge-remove",
                      onClick: _withModifiers($event => ($setup.store.removeMergeSegment(i)), ["stop"]),
                      title: "Remove this merge pair"
                    }, "×", 8 /* PROPS */, _hoisted_37)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Holographic result flash (shows below bar for inline results during merge) "),
    _createVNode(_Transition, { name: "flash-pop" }, {
      default: _withCtx(() => [
        ($setup.hasInlineResult)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["nge-smo-result-flash", { success: $setup.resultIsSuccess, error: $setup.resultIsError }])
            }, [
              _createElementVNode("span", _hoisted_38, _toDisplayString($setup.resultIsSuccess ? '✓' : '✗'), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_39, _toDisplayString($setup.store.resultText), 1 /* TEXT */),
              ($setup.resultIsError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Press Enter to retry"))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}